/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { ComparePage } from 'landing-pages/compare/ComparePage';
import { getOpenCorporatesCompareData } from 'landing-pages/compare/data/opencorporates';

export const GlobalDatabaseVsOpenCorporatesPage = () => {
  const { t } = useInt();

  return <ComparePage data={getOpenCorporatesCompareData(t)} />;
};
